import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface ResetsOnTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const ResetsOnTooltip: React.FC<ResetsOnTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        <Trns
          source={
            'Set by your card issuer. Your credit limit resets on this date each cycle.'
          }
        />
      </p>
    </Tooltip>
  )
}

export default ResetsOnTooltip
